// todo: https://github.com/datejs/Datejs

const intlFormatter = new Intl.NumberFormat('ru-RU', {
    style: 'currency', currency: 'RUB',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});

var padZero = function (integer) {
    return integer < 10 ? '0' + integer : '' + integer
};

var months = ['Янв', 'Февр', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'];

const mixin = {
    methods: {
        dateNoTime(value) {
            return this.date(value, false, true);
        },
        dateToNow(value) {
            let once = new Date(value);
            let today = new Date();
            return (today.getTime() - once.getTime()) / (1000*60*60*24);
        },
        date(value, techFormat, hideTime) {
            if (!value) return '';

            if (value.replace) { value = value.replace(/\s/, 'T'); }
            let d = new Date(value);
            let today = new Date();
            let time = padZero(d.getHours()) + ':' + padZero(d.getMinutes())

            let thisYear = d.getYear() == today.getYear()
            
            if (!techFormat && thisYear && d.getMonth() == today.getMonth()) {
                if (d.getDate() == today.getDate()) {
                    return 'Сегодня' + (hideTime?'':', ' +time);
                } else if (d.getDate()+1 == today.getDate()) {
                    return 'Вчера' + (hideTime?'':', ' + time);
                }
            }

            if (techFormat) {
                return d.getFullYear() + '-' + padZero(d.getMonth()+1) + '-' + padZero(d.getDate())
            } else {
                return padZero(d.getDate()) + ' ' + months[d.getMonth()] + ' ' + ( thisYear? '' : (d.getYear()-100)+'' )
                    + (hideTime?'':' ' + time);
            }
        },

        numerable (number, titles) {
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
        },

        rubles(value) {
            return intlFormatter.format(parseFloat(value))
        }
    }
};

export default {
    install (Vue, options) {
        Vue.mixin(mixin)
    }
}



// WEBPACK FOOTER //
// ./src/plugins/moment.js